// extracted by mini-css-extract-plugin
export default {"component":"CheckoutVoucher_component__Ga0ko","head":"CheckoutVoucher_head__sbsOW","value":"CheckoutVoucher_value__biXrO","box":"CheckoutVoucher_box__ewJrS"};